function fn_layout_main() {
    $("body").removeClass("mod--preload");
    setTimeout(function () {
        $("body").addClass("mod--loaded");
    }, 300);

    fn_nl_lib_anchor();
    fn_scrollreveal();

    $(".lib--parallax").find("img:not(.lazyload)").parent().parallax();
    $(document).on('lazybeforeunveil', function(e){
        if ($(e.target).parent().hasClass("lib--parallax")) {
            $(e.target).parent().parallax();
        }
    });

    nl_lib_dialog.init();
    $("[data-switch]").nl_lib_switch();
    $(".part_ui_btn").nl_lib_ripple();

    $(document).on("click", "[data-print]", function() {
        printJS($(this).data("print"));
    });

    var picture = document.createElement('picture'),
        strObj = '' + picture;
    if(strObj.indexOf("HTMLPictureElement") == -1)
    {
        $.getScript($cdnjs.picturefill);
    }

    var image_dialog = $(document).find("[data-image-dialog]");
    if(image_dialog.length){
        setTimeout(function () {
            image_dialog.click();
        },5000);
    }
}
